<template>
  <v-dialog v-model="store.state.aboutDialogVisible" max-width="600px" v-if="store.state.aboutDialogVisible" :retain-focus="false" style="background: white">

    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">About</v-btn>
    </template>

    <v-card class="mx-auto aboutBg" rounded="xxl">
      <div class="content">
        <v-card-title class="headline">About Nomad Map</v-card-title>
        <v-card-text style="font-size: large">
          <p><strong>Version:<br></strong>0.5.1</p>
          <p><strong>Developed by:<br></strong>Aviad Gershon</p>
          <p><strong>Contact Information:<br></strong><a href="mailto:info@thenomadmap.com" style="text-decoration: none!important; color: black!important;">Info@thenomadmap.com</a></p>
        </v-card-text>
        <v-card-actions>
<!--          <v-btn color="white" text @click="store.commit('toggleEventsVisibility')">Events</v-btn>-->
<!--          <v-spacer></v-spacer>-->
          <v-btn color="blue darken-1" text @click="store.commit('setAboutDialogVisibility', false)">Close</v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  computed: {
    store() {
      return store
    }
  },
  data () {
    return {
      dialog: false,
    }
  },
}
</script>

<style>
  .aboutBg {
    background-image: url("~@/assets/about_bg.webp")  ;
    background-size: cover;
  }
  .content {
    background-color: rgba(255,255,255,0.8);
  }
  .headline {
    font-size: 2rem;
    font-weight: bold;
    opacity: 1.0!important;
  }
</style>
